export default "__VITE_ASSET__BAP7dUBk__"